import { useCallback, useEffect, useState } from 'react';
import { t } from '../i18n';
import { agoMs as ago } from './format';
import { api } from './api';

interface Status {
  lastSync: { started_at: number; finished_at: number | null; ok: number | null } | null;
  syncing: boolean;
}

/** „Zuletzt synchronisiert" plus Knopf; fragt während eines Laufs alle 5 s nach. */
export function useSyncStatus() {
  const [status, setStatus] = useState<Status | null>(null);
  const refresh = useCallback(() => api<Status>('/api/status').then(setStatus).catch(() => {}), []);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  useEffect(() => {
    if (!status?.syncing) return;
    const t = setInterval(() => void refresh(), 5000);
    return () => clearInterval(t);
  }, [status?.syncing, refresh]);
  const start = useCallback(() => {
    void api('/api/sync', { method: 'POST' }).then(() => setStatus((s) => (s ? { ...s, syncing: true } : s)));
  }, []);
  const last = status?.lastSync;
  const label = !last
    ? t('shell.syncNever')
    : last.ok === 0
      ? t('shell.syncFailed', { ago: ago(last.started_at) })
      : `${ago(last.finished_at ?? last.started_at)} · Garmin`;
  return { label, running: !!status?.syncing, start };
}
